const FAQsSchema = {
  title: 'FAQs',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'backgroundImage',
        'header',
        'items'
      ],
    },
  ],

  properties: {
    backgroundImage: {
      title: 'Background Image',
      type: 'string',
      widget: 'image',
    },
    header: {
      title: 'Header',
      type: 'string',
    },
    items: {
      title: 'Items',
      widget: 'object_list',
      schema: {
        title: 'Item',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: [
              'question',
              'answer',
            ],
          },
        ],
        properties: {
          question: {
            title: 'Question',
            type: 'string',
          },
          answer: {
            title: 'Answer',
            widget: 'textarea',
          }
        },
        required: [],
      },
    },
  },

  required: [],
};

export default FAQsSchema;
